import { apiService } from '../../../shared/services/apiServices';
import technicianEndpoints from './technicianEndpoints';
import { TechnicianDetailResponse } from '../types/editTechnicianType';

export interface GetTechnicianByIdResult {
  success: boolean;
  data?: TechnicianDetailResponse;
  forbidden?: boolean;
  error?: string;
}

export const getTechnicianByIdApiService = async (
  id: string
): Promise<GetTechnicianByIdResult> => {
  const url = `${technicianEndpoints.TECHNICIANS}/${id}`;

  try {
    const result = await apiService.getAPI(url, {
      skipGlobalErrorRedirect: true,
    });

    if (result.error && result.status === 403) {
      return { success: false, forbidden: true };
    }

    if (!result.error) {
      const responseData = result.data as {
        technician: TechnicianDetailResponse;
      };
      return { success: true, data: responseData.technician };
    }

    const errorData = result.data as { message?: string };
    return {
      success: false,
      error: errorData?.message || 'Failed to fetch technician',
    };
  } catch (_error) {
    return { success: false, error: 'Failed to fetch technician' };
  }
};
